module.exports = __webpack_public_path__ + "img/banner-faq.5a72024e.jpg";